
export const DATA_KEY = "data"